import {ChangeDetectionStrategy, Component, inject, input} from "@angular/core"
import {ButtonComponent} from "@app/common/components/buttons/button/button.component"
import {ConfigMenuService} from "@app/common/components/viewers/configurator/config-menu/services/config-menu.service"
import {DialogService} from "@app/common/services/dialog/dialog.service"
import {MaterialInfo} from "@cm/template-nodes"
import {SelectMaterialComponent} from "@app/platform/components/materials/select-material/select-material.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-select-material-button",
    templateUrl: "./select-material.component.html",
    styleUrls: ["./select-material.component.scss"],
    imports: [ButtonComponent],
})
export class SelectMaterialButton {
    readonly $materialInfo = input.required<MaterialInfo>({alias: "materialInfo"})

    private readonly dialog = inject(DialogService)
    private readonly configMenuService = inject(ConfigMenuService)

    chooseMaterialForInput() {
        this.dialog.selectInDialog(SelectMaterialComponent, {
            filters: {meshSpecific: false},
            onSelect: ({legacyId}) => {
                this.configMenuService.emitMaterialSelected({input: this.$materialInfo(), legacyId})
            },
        })
    }
}
